// IMPORTs HERE
import { calculateYearsOfExperience } from "utils/functions";

// GLOBAL VARIABLEs
const space = `\u00A0`;

/* *********************************************************************************************************** */
/* *********************************************************************************************************** */

export const fullName = "Paras Agrawal";
export const currentCompanyName = "M1xchange";
export const currentCompanySite = "https://m1xchange.com/";
export const emailId = "parasagrawal71+app@gmail.com";
export const designation = "Senior Software Engineer";
export const careerStartDate = "2019-07-15"; // 15 July 2019; Format: YYYY-MM-DD;
export const YOE = calculateYearsOfExperience(careerStartDate);
export const RESUME_URL = "https://drive.google.com/file/d/1YkSDJ4uh3qjGXzDVi84iGFf6kQwB9_Nr/view";
export const SELF_PICTURE_URL = `https://github.com/parasagrawal71.png`;
export const shortDescriptionHtml = `Hello! 👋🏼${space.repeat(2)}I'm a guy slightly obsessed 
  with code quality. I have ${YOE} years of experience in software development and cloud technologies. I am currently working 
  at <a href="${currentCompanySite}" target="_blank">${currentCompanyName}</a>.`;
